import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material';

type GridCardProps = {
  title: string | React.ReactNode;
  children: React.ReactNode;
  fullscreen?: boolean;
};

export const GridCard = ({ title, children, fullscreen }: GridCardProps) => {
  const { palette } = useTheme();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Card variant="outlined" sx={{ height: '100%' }}>
        <CardHeader
          action={
            fullscreen ? (
              <IconButton aria-label="fullscreen" onClick={handleOpen} sx={{ p: 0, mr: 0.5 }}>
                <FullscreenIcon />
              </IconButton>
            ) : null
          }
          title={title}
          sx={{
            borderBottom: '1px solid',
            borderColor: palette.divider,
            padding: '10px',
            height: '40px',
          }}
        />
        <CardContent>{children}</CardContent>
      </Card>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ padding: 0 }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            height: '100%',
          }}
        >
          <CardHeader
            title={
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <IconButton aria-label="close" onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
                {title}
                <IconButton aria-label="close-fullscreen" onClick={handleClose}>
                  <FullscreenIcon />
                </IconButton>
              </Box>
            }
            sx={{ borderBottom: '1px solid', borderColor: palette.divider, padding: '10px' }}
          />
          <CardContent
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              '.line-chart': {
                position: 'relative',
                height: '95%',
                overflow: 'auto hidden',
                padding: '10px',
              },
              '.adp-mass-flow-meter-chart': {
                position: 'relative',
                height: '95%',
                overflow: 'auto hidden',
              },
            }}
          >
            {children}
          </CardContent>
        </Box>
      </Modal>
    </>
  );
};
